// Qué pasó con cada respuesta de Benito: el hilo que amarra la pregunta a lo
// que vino después (2026-09-27).
//
// EL PROBLEMA. El fundador lo dijo así: "¿de qué sirve solo reunir las
// preguntas? También podemos reunir las respuestas y entender qué necesita el
// usuario". Hasta hoy el 👍/👎, el copiar y el detener llegaban a eventos_v2
// SUELTOS: se sabía cuántos pulgares abajo hubo, pero no de qué pregunta ni de
// qué tema. Con eso no se puede decir "en fármacos Benito convence y en
// cálculos no".
//
// LA DECISIÓN (criterio del fundador aplicado, 2026-09-27): el TEXTO de la
// respuesta NO se guarda. La Política y el switch de Mi perfil prometen por
// escrito "solo la pregunta, nunca la respuesta", el póster del congreso
// promete el autoborrado del contenido clínico al terminar el turno, y una
// respuesta puede repetir datos del registro efímero del paciente (el bloque
// [Ahora] entra en cada conversación) que ninguna guarda de PII caza. Lo que
// se reúne de la respuesta es lo que PASÓ con ella: si sirvió, si la copiaron,
// si la cortaron, si Benito tuvo que ir a la web. Todo catálogo cerrado.
//
// EL AMARRE es un id aleatorio por respuesta (`ref`): viaja en el evento del
// mensaje, en la fila de la pregunta capturada (si se capturó) y en cada gesto
// posterior. No es un dato de la persona: es un número al azar que solo sirve
// para juntar filas que ya eran de la misma persona.

// uuid v4 canónico: la columna preguntas_donadas.ref es uuid, así que lo que
// no calce con esto no se manda (un ref mal formado haría fallar el insert y
// la captura se perdería por un detalle).
export const REF_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;

export function esRefValida(ref) {
  return typeof ref === "string" && REF_RE.test(ref);
}

/**
 * Id aleatorio para amarrar una respuesta a sus señales. Usa crypto.randomUUID
 * cuando existe (todo navegador y WebView moderno) y cae a getRandomValues;
 * sin ninguno de los dos devuelve null y el llamador sigue sin amarre (fail-safe
 * hacia no mandar nada, jamás hacia romper la conversación).
 */
export function nuevaRef() {
  try {
    const c = typeof crypto !== "undefined" ? crypto : null;
    if (c && typeof c.randomUUID === "function") {
      const r = c.randomUUID();
      return esRefValida(r) ? r : null;
    }
    if (c && typeof c.getRandomValues === "function") {
      const b = new Uint8Array(16);
      c.getRandomValues(b);
      b[6] = (b[6] & 0x0f) | 0x40; // versión 4
      b[8] = (b[8] & 0x3f) | 0x80; // variante RFC 4122
      const h = [...b].map((x) => x.toString(16).padStart(2, "0")).join("");
      return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
    }
  } catch { /* sin crypto: sin amarre */ }
  return null;
}

/**
 * Las claves que un gesto sobre una burbuja (👍/👎, copiar) le suma a su
 * evento: el amarre y el tema de la pregunta que la originó. Solo ids de
 * catálogo; una burbuja restaurada de un hilo viejo (sin estas claves) no
 * suma nada y el evento sale igual que antes.
 */
export function senalesDeBurbuja(burbuja) {
  const out = {};
  if (!burbuja || typeof burbuja !== "object") return out;
  if (esRefValida(burbuja.ref)) out.ref = burbuja.ref;
  if (typeof burbuja.tema === "string" && burbuja.tema) out.tema = burbuja.tema;
  if (typeof burbuja.subtema === "string" && burbuja.subtema) out.subtema = burbuja.subtema;
  return out;
}
